import React, {useCallback, useEffect, useReducer} from "react";
import {connect} from "react-redux";
import clone from "lodash/clone";

import PRICING_POPUP_TYPES from "./pricingPopupTypes";
import {showPricingPopup} from "../pricingActions";
import PricingPopupContext, {initialPricingPopupValues, pricingPopupContextReducer} from "./PricingPopupContext";
import PricingPopupFeaturesProperties from "./PricingPopupFeaturesProperties";
import PricingPopupSaveButton from "./PricingPopupSaveButton";
import PricingPopupFeatureGroups from "./PricingPopupFeatureGroups";
import PricingPopupAssignFeatures from "./PricingPopupAssignFeatures";
import PricingPopupAllCatalogs from "./PricingPopupAllCatalogs";

const getTitle = (pricingPopupType, activeCatalog) => {
  switch (pricingPopupType) {
    case PRICING_POPUP_TYPES.featuresProperties:
      return {title: "Extra properties", subTitle: "Add extra properties to you selection."}
    case PRICING_POPUP_TYPES.featureGroups:
      return {title: "Enable Display Groups", subTitle: "To enable display groups set the following parameters."}
    case PRICING_POPUP_TYPES.allCatalogs:
      return {title: "Current Catalogs", subTitle: "Select the catalogs to be added to this project."}
    case PRICING_POPUP_TYPES.assignFeatures: {
      const name = activeCatalog ? activeCatalog.newCustomName || activeCatalog.name : "";
      return {
        title: "Assign Items" + (name ? " to " + name : ""),
        subTitle: "To create a new price list set the following parameters."
      }
    }
    default:
      return {title: "Some Title", subTitle: "Undefined"}
  }
}

const getContent = (pricingPopupType) => {
  switch (pricingPopupType) {
    case PRICING_POPUP_TYPES.featuresProperties:
      return <PricingPopupFeaturesProperties/>
    case PRICING_POPUP_TYPES.featureGroups:
      return <PricingPopupFeatureGroups/>
    case PRICING_POPUP_TYPES.assignFeatures:
      return <PricingPopupAssignFeatures/>
    case PRICING_POPUP_TYPES.allCatalogs:
      return <PricingPopupAllCatalogs/>
    default:
      return null
  }
}

const PricingPopup = (props) => {

  const {showPricingPopup, pricingPopupType, pricingPopupOpened, pricingCatalogs, pricingFeaturesColumns,
    pricingFeatureGroupsChecked} = props;

  const [pricingPopupState, pricingPopupDispatch] = useReducer(pricingPopupContextReducer,
    initialPricingPopupValues
  )

  const isAssignFeaturesPopup = pricingPopupType === PRICING_POPUP_TYPES.assignFeatures;

  useEffect(() => {
    if (pricingPopupOpened) { // reset on popup open
      const activeCatalog = isAssignFeaturesPopup ? pricingCatalogs.find(catalog => catalog.isActive) : null;
      pricingPopupDispatch({
        ...clone(initialPricingPopupValues),
        featuresProperties: [...pricingFeaturesColumns],
        featureGroupsChecked: [...pricingFeatureGroupsChecked],
        allCatalogsChecked: [],
        activeCatalog,
      })
    }
    document.addEventListener("keydown", onEscapePress);
    return () => {
      document.removeEventListener("keydown", onEscapePress);
    }
  }, [pricingPopupOpened]);

  const closePopup = () => {
    showPricingPopup(false);
  };

  const onEscapePress = useCallback((evt) => {
    const isEscape = ("key" in evt) ? (evt.key === "Escape" || evt.key === "Esc") : (evt.keyCode === 27);
    if (isEscape && showPricingPopup) {
      closePopup()
    }
  }, [closePopup, showPricingPopup])

  const {title, subTitle} = getTitle(pricingPopupType, pricingPopupState.activeCatalog);

  return (
    <PricingPopupContext.Provider value={{pricingPopupState, pricingPopupDispatch}} >
      <div className={"pr-popup color-textgray text-left flex flex--column border-box width-100 bg-white p-1 pr-popup--" + pricingPopupType
        + (pricingPopupOpened ? "" : " pr-popup--hidden")
        + (isAssignFeaturesPopup ? " height-100" : "")}>
        <span className="color-blue flex--center font--22 flex flex--start mb-025">{title}</span>
        <p className="margin-0 font--15 color-gray4">{subTitle}</p>
        {getContent(pricingPopupType)}
        <div className="flex flex--center flex--end">
        <button className="ui-button2 bold ui-button2--blue" onClick={closePopup}>Cancel</button>
          <PricingPopupSaveButton closePopup={closePopup}/>
        </div>
      </div>
    </PricingPopupContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {pricingPopupOpened} = store.popups;
  const {pricingPopupType, pricingCatalogs, pricingFeaturesColumns, pricingFeatureGroupsChecked} = store.pricingState;
  return {
    pricingPopupOpened,
    pricingPopupType,
    pricingCatalogs,
    pricingFeaturesColumns,
    pricingFeatureGroupsChecked,
  };
};

const mapDispatchToProps = {
  showPricingPopup
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(PricingPopup)
)
